import { Avatar, Box, Dialog, Divider, Drawer, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/People";
// Assuming these paths are correct relative to the component's location
// In a real setup, you might use a public folder or a build process to handle these assets
import HomeIcon from "../../svg/home.svg"; // Adjust path as necessary
import ArticleIcon from "../../svg/articledrawer.svg"; // Adjust path as necessary
import InstaIcon from "../../svg/instagram.svg"; // Adjust path as necessary
import LanguageIcon from "../../svg/language.svg"; // Adjust path as necessary
import PromotionIcon from "../../svg/promotion.svg"; // Adjust path as necessary
import TwitterIcon from "../../svg/twitter.svg"; // Adjust path as necessary
import FacebookIcon from "../../svg/facebook1.svg"; // Adjust path as necessary
import Youtubeicon from "../../svg/youtube.svg"; // Adjust path as necessary
import WhatsappIcon from "../../svg/whatsappPrimary.svg"; // Adjust path as necessary
import TermsOfUseIcon from "../../svg/termsOfUse.svg"; // Adjust path as necessary
import PrivacyPolicyIcon from "../../svg/privancyPolicy.svg"; // Adjust path as necessary
import AboutIcon from "../../svg/about.svg"; // Adjust path as necessary
import authorIcon from "../../svg/author.svg";
import ContactUs from "../../svg/contactUs.svg"; // Adjust path as necessary
import ProfileService from "../../Services/Profile"; // Adjust path as necessary
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import i18n from "../../i18n"; // Adjust path as necessary

// Dummy image for user profile fallback
const dummyImage = "https://placehold.co/1000x1000/cccccc/333333?text=No+Image"; // Placeholder for dummy image

interface DrawerProps {
  openDrawer: boolean;
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  toggleDrawer: (open: boolean) => () => void;
  onContactUs?: () => void;
}

type DrawerItemType = {
  icon?: string | React.ReactNode;
  label: string;
  onClick?: () => void;
  iconSize?: React.CSSProperties;
  style?: React.CSSProperties;
};

const MobileDrawer = ({ openDrawer, toggleDrawer, setOpenDrawer, onContactUs }: DrawerProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [languageModal, setLanguageModal] = useState(false);
  const [userData, setUserData] = useState<any>(null);
  // Initialize selectedLanguage from localStorage. If not found, default to 'hindi'.
  // यदि localStorage में कोई भाषा सहेजी नहीं गई है, तो डिफ़ॉल्ट रूप से 'hindi' चुनें।
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("language") || 'hindi');

  useEffect(() => {
    // This effect runs once on component mount to ensure the default language is set in localStorage
    // यह प्रभाव घटक माउंट पर एक बार चलता है ताकि यह सुनिश्चित हो सके कि डिफ़ॉल्ट भाषा localStorage में सेट है।
    const storedLanguage = localStorage.getItem("language");
    if (!storedLanguage) {
      localStorage.setItem("language", 'hindi');
      localStorage.setItem("lan", 'hi');
      i18n.changeLanguage('hi');
    } else if (storedLanguage !== selectedLanguage) {
      // If localStorage has a language but it's different from the initial state (e.g., due to a quick navigation),
      // ensure the state and i18n are in sync.
      setSelectedLanguage(storedLanguage);
      i18n.changeLanguage(storedLanguage === 'hindi' ? 'hi' : 'en');
    }
  }, []); // Empty dependency array means this effect runs only once on mount

  useEffect(() => {
    if (openDrawer) {
      // Fetch user profile based on the currently selected language
      // वर्तमान में चयनित भाषा के आधार पर उपयोगकर्ता प्रोफ़ाइल प्राप्त करें।
      ProfileService.getProfile(selectedLanguage) // Use selectedLanguage state
        .then((res: any) => {
          setUserData(res?.result);
        })
        .catch((error: any) => {
          console.error("API Call Error:", error);
        });
    }
  }, [openDrawer, selectedLanguage]); // Add selectedLanguage to dependency array to re-fetch if language changes

  const handleNavigate = (path: string, state?: any) => () => {
    navigate(path, { state });
    setOpenDrawer(false);
  };

  const handleChangeLanguage = (lang: string) => {
    setSelectedLanguage(lang);
    localStorage.setItem("language", lang); // Store selected language in localStorage
    localStorage.setItem("lan", lang === "hindi" ? "hi" : "en");
    i18n.changeLanguage(lang === "hindi" ? "hi" : "en"); // Update i18n instance to change the app's language
    setLanguageModal(false);
  };

  const drawerItems: DrawerItemType[] = [
    { icon: HomeIcon, label: t("Home_tr"), onClick: handleNavigate("/") },
    { icon: AboutIcon, label: t("Introduction_tr"), onClick: handleNavigate("/about") },
    { icon: PromotionIcon, label: t("publicity_tr"), onClick: handleNavigate("/publicity") },
    // { icon: ArticleIcon, label: t("Article_tr"), onClick: handleNavigate("/mbBooks",{state:{allArticles:true}})}, 
    { icon: ArticleIcon, label: t("Article_tr"), onClick: handleNavigate("/mbBooks?allArticles=true") },
  ];

  const helpSupport: DrawerItemType[] = [
    { icon: LanguageIcon, label: t("Language_tr"), onClick: () => setLanguageModal(true) },
    { icon: ContactUs, label: t("Contact_tr"), onClick: () => { onContactUs?.(); setOpenDrawer(false); } },
    { icon: PrivacyPolicyIcon, label: t("Privacy_Policy_tr"), onClick: handleNavigate("/privacy-policy") },
    { icon: TermsOfUseIcon, label: t("Terms_of_Use_tr"), onClick: handleNavigate("/terms-of-use") },
  ];

  const legendsIntroduction: DrawerItemType[] = [
    { icon: <PeopleIcon />, label: t("Honorable_Shri_Jayadayal_Ji"), onClick: handleNavigate("/legendsIntroduction", { id: "5bbc5fa51fd2d735b0087d34" }) },
    { icon: <PeopleIcon />, label: t("Honorable_Shri_Hanumanprasad_ji_poddar"), onClick: handleNavigate("/legendsIntroduction", { id: "5bbc5fcd1fd2d735b0087d35" }) },
    { icon: <PeopleIcon />, label: t("Honorable_Swami_Shri_Ramsukhdas_Ji"), onClick: handleNavigate("/legendsIntroduction", { id: "5bbc60101fd2d735b0087d36" }) },
  ];

  const socialLinks: DrawerItemType[] = [
    { icon: Youtubeicon, label: t("YouTube_tr"), onClick: () => window.open("https://www.youtube.com/gitasevaapp", "_blank") },
    { icon: FacebookIcon, label: t("Facebook_tr"), onClick: () => window.open("https://www.facebook.com/gitasevatrust", "_blank") },
    { icon: TwitterIcon, label: t("Twitter_tr"), onClick: () => window.open("https://x.com/gitasevaapp", "_blank") },
    { icon: InstaIcon, label: t("Instagram_tr"), onClick: () => window.open("https://www.instagram.com/gitasevatrust", "_blank") },
    { icon: WhatsappIcon, label: t("WhatsApp"), onClick: () => window.open("https://www.whatsapp.com/channel/0029VaG8EhS9Bb5trESdPZ05", "_blank") },
  ];

  const renderSection = (items: DrawerItemType[]) => (
    <List disablePadding>
      {items.map(({ icon, label, onClick, iconSize, style }, i) => (
        <ListItem button key={i} onClick={onClick} sx={{ pl: 2 }}>
          {icon && (
            <ListItemIcon sx={{ minWidth: 40 }}>
              {typeof icon === "string" ? (
                <img src={icon} style={{ width: 24, height: 24, filter: "invert(47%) sepia(89%) saturate(1349%) hue-rotate(8deg) brightness(101%) contrast(105%)", ...iconSize }} alt={label} />
              ) : (
                <Box sx={{ color: "#f97316", display: "flex", ...iconSize }}>{icon}</Box>
              )}
            </ListItemIcon>
          )}
          <ListItemText primary={<Typography sx={{ fontSize: 13, ...style }}>{label}</Typography>} />
        </ListItem>
      ))}
    </List>
  );

  const LanguageDialog = () => {
    const languageOptions = [
      { key: 'hindi', label: t("language.hindi") },
      { key: 'english', label: t("language.english") },
    ];

    return (
      <Box sx={{ width: 250, textAlign: "center" }}>
        <Typography variant="h6" sx={{ py: 2 }}>{t("Select_Language_tr")}</Typography>
        <Divider />
        {languageOptions.map((option, i) => (
          <React.Fragment key={option.key}>
            <ListItem button onClick={() => handleChangeLanguage(option.key)} sx={{ pr: 0 }}>
              <DoubleArrowIcon sx={{ fontSize: 18, mr: 1, color: "primary.main" }} />
              <ListItemText primary={option.label} />
              <ListItemIcon sx={{ ml: "auto", minWidth: 40 }}>
                {selectedLanguage === option.key ? <RadioButtonCheckedIcon color="primary" /> : <RadioButtonUncheckedIcon />}
              </ListItemIcon>
            </ListItem>
            {i < languageOptions.length - 1 && <Divider />}
          </React.Fragment>
        ))}
        <Divider />
        <ListItem button onClick={() => setLanguageModal(false)}>
          <ListItemText primary={t("Cancel_tr")} sx={{ textAlign: 'center' }} />
        </ListItem>
      </Box>
    );
  };

  return (
    <>
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: 250,
            boxSizing: 'border-box',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          },
        }}
      >
        <Dialog open={languageModal} onClose={() => setLanguageModal(false)}>
          <LanguageDialog />
        </Dialog>

        {/* <Box sx={{ position: 'relative', height: 320, overflow: 'hidden' }}> 
          <Avatar
            src={userData?.imageThumbPath || dummyImage}
            sx={{ height: "100%", width: "100%" }}
            variant="square"
            alt="User Profile"
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: 'white',
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              boxShadow: '0px -5px 8px 5px rgba(0, 0, 0, 0.3)', 
              cursor: 'pointer',
            }}
            onClick={() => { localStorage.getItem("Token") ? navigate("/myProfile") :navigate("/loginPage") ; setOpenDrawer(false); }}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              {userData?.name || t("Guest_User_tr")} 
            </Typography>
            <ArrowForwardIosIcon sx={{ fontSize: '1.2rem' }} />
          </Box>
        </Box> */}

        <Box sx={{ flexGrow: 1, overflowY: 'auto', pb: 2 }}>
          {renderSection(drawerItems)}

          <Divider sx={{ bgcolor: "lightslategray", my: 1 }} />
          <Box sx={{ display: "flex", alignItems: "center", px: 2, pt: 2 }}>
            <img src={authorIcon} alt="" style={{ width: 20, height: 20, marginRight: 8, filter: "invert(47%) sepia(89%) saturate(1349%) hue-rotate(8deg) brightness(101%) contrast(105%)" }} />
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{t("Legends_Introduction_tr")}</Typography>
          </Box>
          {renderSection(legendsIntroduction)}

          <Divider sx={{ bgcolor: "lightslategray", my: 1 }} />
          <Typography sx={{ p: 2, fontSize: 14, fontWeight: 600 }}>{t("help_support")}</Typography>
          {renderSection(helpSupport)}

          <Divider sx={{ bgcolor: "lightslategray", my: 1 }} />
          <Typography sx={{ p: 2, fontSize: 14, fontWeight: 600 }}>{t("Social_media_link")}</Typography>
          {renderSection(socialLinks)}
        </Box>
      </Drawer>
    </>
  );
};

export default MobileDrawer;
